import React from 'react';

function DatePicker({ value, onChange, label, minDate }) {
  const [open, setOpen] = React.useState(false);
  const [viewDate, setViewDate] = React.useState(() => value ? new Date(value + 'T00:00:00') : new Date());
  const ref = React.useRef(null);
  React.useEffect(() => { const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }; document.addEventListener('mousedown', h); return () => document.removeEventListener('mousedown', h); }, []);
  React.useEffect(() => { if (value) setViewDate(new Date(value + 'T00:00:00')); }, [value]);
  const M = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const D = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
  const y = viewDate.getFullYear(), m = viewDate.getMonth();
  const fd = new Date(y, m, 1).getDay(), dim = new Date(y, m + 1, 0).getDate();
  const si = (fd + 6) % 7, pd = new Date(y, m, 0).getDate();
  const cells = [];
  for (let i = si - 1; i >= 0; i--) cells.push({ day: pd - i, cur: false, dt: null });
  for (let d = 1; d <= dim; d++) { const ds = y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0'); cells.push({ day: d, cur: true, dt: ds, dis: minDate && ds < minDate }); }
  for (let d = 1; d <= 42 - cells.length; d++) cells.push({ day: d, cur: false, dt: null });
  const now = new Date(), ts = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
  const dv = value ? new Date(value + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div style={{ fontSize: '0.75rem', color: 'var(--text-muted, #4a4a5a)', marginBottom: '0.25rem', fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase' }}>{label}</div>
      <div onClick={() => setOpen(!open)} style={{
        width: '100%',
        background: 'var(--bg-input, #0e0e15)',
        border: open ? '1px solid var(--border-hover, rgba(255,255,255,0.14))' : '1px solid var(--border-subtle, rgba(255,255,255,0.06))',
        borderRadius: 'var(--radius-md, 8px)',
        color: value ? 'var(--text-primary, #e8e8ed)' : 'var(--text-muted, #4a4a5a)',
        padding: '0.625rem 0.875rem',
        fontSize: '0.82rem',
        fontFamily: 'var(--font-sans)',
        cursor: 'pointer',
        boxSizing: 'border-box',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        transition: 'border-color 0.2s ease',
      }}>
        <span>{dv || 'Select date'}</span>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted, #4a4a5a)" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
      </div>
      {open && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100, marginTop: 4,
          background: 'var(--bg-elevated, #1a1a24)',
          border: '1px solid var(--border-default, rgba(255,255,255,0.09))',
          borderRadius: 'var(--radius-lg, 12px)',
          boxShadow: '0 12px 40px rgba(0,0,0,0.5)',
          padding: '0.75rem',
          minWidth: 260,
          animation: 'modalSlideIn 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
            <button type="button" onClick={() => setViewDate(new Date(y, m - 1, 1))} style={{
              background: 'rgba(255,255,255,0.04)', border: '1px solid var(--border-subtle, rgba(255,255,255,0.06))', borderRadius: 'var(--radius-sm, 6px)',
              color: 'var(--text-secondary, #8b8b9e)', cursor: 'pointer', width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.7rem',
              transition: 'all 0.15s',
            }}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            </button>
            <span style={{ fontSize: '0.82rem', fontWeight: 700, color: 'var(--text-primary, #e8e8ed)', fontFamily: 'var(--font-display)' }}>{M[m]} {y}</span>
            <button type="button" onClick={() => setViewDate(new Date(y, m + 1, 1))} style={{
              background: 'rgba(255,255,255,0.04)', border: '1px solid var(--border-subtle, rgba(255,255,255,0.06))', borderRadius: 'var(--radius-sm, 6px)',
              color: 'var(--text-secondary, #8b8b9e)', cursor: 'pointer', width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.7rem',
              transition: 'all 0.15s',
            }}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>
            </button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 2, marginBottom: 4 }}>
            {D.map(d => (<div key={d} style={{ textAlign: 'center', fontSize: '0.7rem', fontWeight: 700, color: 'var(--text-muted, #4a4a5a)', padding: '0.25rem 0', fontFamily: 'var(--font-sans)' }}>{d}</div>))}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 2 }}>
            {cells.map((c, i) => {
              const sel = c.dt === value, tod = c.dt === ts; return (
                <div key={i} onClick={() => { if (c.cur && !c.dis) { onChange(c.dt); setOpen(false); } }} style={{
                  textAlign: 'center', padding: '0.35rem 0', fontSize: '0.75rem', borderRadius: 'var(--radius-sm, 6px)',
                  cursor: c.cur && !c.dis ? 'pointer' : 'default', fontWeight: sel ? 700 : 400,
                  color: !c.cur ? 'rgba(255,255,255,0.04)' : c.dis ? 'var(--text-muted, #4a4a5a)' : sel ? '#fff' : tod ? 'var(--accent-blue, #3b82f6)' : 'var(--text-secondary, #8b8b9e)',
                  background: sel ? 'var(--accent-blue, #3b82f6)' : 'transparent',
                  transition: 'all 0.12s',
                  border: tod && !sel ? '1px solid rgba(59,130,246,0.25)' : '1px solid transparent'
                }} onMouseOver={e => { if (c.cur && !c.dis && !sel) e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; }} onMouseOut={e => { if (!sel) e.currentTarget.style.background = 'transparent'; }}>{c.day}</div>);
            })}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem', padding: '0.25rem 0', borderTop: '1px solid var(--border-subtle, rgba(255,255,255,0.06))' }}>
            <button type="button" onClick={() => { onChange(''); setOpen(false); }} style={{ background: 'none', border: 'none', color: 'var(--text-muted, #4a4a5a)', cursor: 'pointer', fontSize: '0.75rem', fontWeight: 600, fontFamily: 'var(--font-sans)' }}>Clear</button>
            <button type="button" onClick={() => { onChange(ts); setOpen(false); }} style={{ background: 'none', border: 'none', color: 'var(--accent-blue, #3b82f6)', cursor: 'pointer', fontSize: '0.75rem', fontWeight: 600, fontFamily: 'var(--font-sans)' }}>Today</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default DatePicker;
